import IssueDetails from 'app/developer-v3/pages/issues/IssueDetails';
import Issues from 'app/developer-v3/pages/issues';

export default {
  routes: {
    '.': Issues,
    ':issueId': {
      assign: ({ params }) => ({
        params: {
          ...params,
          issueId: parseInt(params.issueId, 10),
        },
      }),
      component: IssueDetails,
    },
  },
};
